import { render, staticRenderFns } from "./StudyPlanTableActions.vue?vue&type=template&id=36422b0a&scoped=true&"
import script from "./StudyPlanTableActions.vue?vue&type=script&lang=js&"
export * from "./StudyPlanTableActions.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlanTableActions.vue?vue&type=style&index=0&id=36422b0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36422b0a",
  null
  
)

export default component.exports